import { Button, ButtonAsButtonProps } from '@gettactic/components';
import { ChevronUp } from 'lucide-react';
import React from 'react';

export interface ToolbarButtonProps extends ButtonAsButtonProps {
  isActive?: boolean;
  hasChevron?: boolean;
}

export const ToolbarButton: React.FC<ToolbarButtonProps> = ({
  isActive,
  children,
  hasChevron,
  ...rest
}) => {
  const chevronProps = hasChevron
    ? ({
        iconSize: 'md',
        iconRight: ChevronUp
      } as ButtonAsButtonProps)
    : undefined;
  return (
    <Button
      className={`px-0 text-ink p-3 hover:bg-gray-100 transition-colors ${
        isActive ? 'bg-blue-50 text-blue-600' : 'text-gray-700'
      }`}
      layout={'squared'}
      variant={isActive ? 'blue' : 'bordlessTransparent'}
      font={isActive ? undefined : 'normalGray'}
      {...chevronProps}
      {...rest}
    >
      {children}
    </Button>
  );
};
